// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"aed37f1d","39":"dce056d2","87":"ac944d42","134":"7f6a67a0","362":"62822c33","438":"f30f7300","473":"526dfe75","577":"70a80b08","580":"add9ce0d","741":"c1488a1d","813":"a712d734","913":"26e342ba","954":"a7c563cd","982":"9c17d3a7"}[chunkId] + ".chunk.js";
};